import {
  AuthenticationDetails,
  CognitoUserPool,
  CognitoUser,
  CognitoUserSession,
  CognitoRefreshToken,
  IAuthenticationDetailsData,
} from 'amazon-cognito-identity-js';
import UserSession from '@app/common/user-session';

// Validate required environment variables
const poolId = process.env.REACT_APP_USER_POOL_ID;
const clientId = process.env.REACT_APP_POOL_WEB_CLI_ID;


const cognitoUserPool = new CognitoUserPool({ 
  UserPoolId: poolId || '', 
  ClientId: clientId || '' 
});

export let cognitoUser: CognitoUser;

export const createCognitoUser = (username) => {
  cognitoUser = new CognitoUser({ Username: username, Pool: cognitoUserPool });
  return cognitoUser;
};

export const authenticateUser = (username: string, password: string) => {
  const authenticationData: IAuthenticationDetailsData = {
    Username: username,
    Password: password,
  };
  
  const authenticationDetails = new AuthenticationDetails(authenticationData);
  cognitoUser = new CognitoUser({ Username: username, Pool: cognitoUserPool });

  return new Promise<CognitoUserSession>((resolve, reject) => {
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: resolve,
      onFailure: reject,
      newPasswordRequired: function (_, __) {
        UserSession.setParams({
          userName: username,
          tempPass: password,
        });
        reject({
          code: 'PasswordResetRequiredException',
          message: 'New Password Required',
          newPasswordRequired: true,
        });
      },
    });
  });
};

export const completeNewPassword = (username, newpassword, data = null) => {
  return new Promise((resolve, reject) => {
    cognitoUser.completeNewPasswordChallenge(newpassword, data, {
      onSuccess: resolve,
      onFailure: reject,
    });
  });
};

export const signOut = (): Promise<void> => {
  if (typeof cognitoUser !== "undefined" && cognitoUser !== null) {
    cognitoUser.signOut();
  }


  UserSession.clear();
  
  return Promise.resolve();
};

export const refreshSession = (token) => {
  const refreshToken = new CognitoRefreshToken({ RefreshToken: token })
  
  // Get username from UserSession
  const username = UserSession.getParam('userName');
  
  // Make sure cognitoUser is initialized - this is crucial after page reloads
  if (!cognitoUser && username) {
    cognitoUser = new CognitoUser({ Username: username, Pool: cognitoUserPool });
  }
  
  // If still no cognitoUser, try to get current user from pool
  if (!cognitoUser) {
    cognitoUser = cognitoUserPool.getCurrentUser();
  }
  
  // If we can't get a cognitoUser, we can't refresh the session
  if (!cognitoUser) {
    return Promise.reject(new Error('No cognito user available for token refresh'));
  }

  return new Promise<CognitoUserSession>((resolve, reject) => {
    cognitoUser.refreshSession(refreshToken, (error, result) => {
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    });
  });
}
